import React from 'react';
import { useTranslation } from 'react-i18next';
import { SfConnector } from 'common/sf-connector';
import { CQAppConstant } from "app-constants";
interface IEmptyStateProps {
    lastSkipped?: boolean;
    onClick?: () => void;
    isPatchCompleted?: boolean;
}

export function CQEmptyState(props: IEmptyStateProps) {
    const {t} = useTranslation();

    function congratulationMessage() {
        const upgradeType = props.isPatchCompleted ? CQAppConstant.MODULE_TYPES.UPDATES.toLocaleLowerCase() : CQAppConstant.MODULE_TYPES.UPGRADES.toLocaleLowerCase();
        const successMessage = t("success_message", { release: SfConnector.releaseVersionName, upgradeType});
        return <h3 className="slds-text-heading_medium">{t("nothing_todo", { msg: successMessage })}</h3>
    }
    return <>
        <div className="slds-illustration slds-illustration_large" style={{width: '100%', height: '500px'}}>
            <img src="/assets/images/illustrations/empty-state-assistant.svg#" alt={t("nothing_todo")} className="slds-illustration__svg"/>
            <div className="slds-text-longform">
                {congratulationMessage()}
                {props.lastSkipped === true ? 
                <button className="slds-button" onClick={props.onClick}>Click to rerun skipped tasks</button> : <></> }
            </div>
        </div>
    </>
}